import { Component } from '@angular/core';

@Component({
  selector: 'cloud-history-table-spinner',
  templateUrl: './history-table-spinner.component.html',
  styleUrls: ['./history-table-spinner.component.scss']
})
export class HistoryTableSpinnerComponent {

}
